// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局 CSS 变量 */
:root {
  /* ========== 主题色 ========== */
  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --primary-gradient-hover: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
  --primary-color: #409EFF;
  --primary-light: #ecf5ff;
  --success-color: #67C23A;
  --success-light: #f0f9eb;
  --warning-color: #E6A23C;
  --warning-light: #fdf6ec;
  --danger-color: #F56C6C;
  --danger-light: #fef0f0;
  --info-color: #909399;
  --info-light: #f4f4f5;

  /* ========== 文字颜色 ========== */
  --text-primary: #303133;
  --text-regular: #606266;
  --text-secondary: #909399;
  --text-placeholder: #c0c4cc;
  --text-white: #ffffff;

  /* ========== 背景色 ========== */
  --bg-page: #f5f7fa;
  --bg-card: #ffffff;
  --bg-hover: #f5f7fa;
  --bg-overlay: rgba(0, 0, 0, 0.5);

  /* ========== 边框颜色 ========== */
  --border-color-base: #dcdfe6;
  --border-color-light: #e4e7ed;
  --border-color-lighter: #ebeef5;
  --border-color-extra-light: #f2f6fc;

  /* ========== 阴影 ========== */
  --shadow-card: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  --shadow-hover: 0 8px 24px 0 rgba(0, 0, 0, 0.12);
  --shadow-dropdown: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  /* ========== 间距 ========== */
  --spacing-xs: 8px;
  --spacing-sm: 12px;
  --spacing-md: 16px;
  --spacing-lg: 20px;
  --spacing-xl: 24px;
  --spacing-2xl: 32px;

  /* ========== 圆角 ========== */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-full: 50%;

  /* ========== 过渡动画 ========== */
  --transition-fast: 0.15s ease;
  --transition-base: 0.3s ease;
  --transition-slow: 0.5s ease;

  /* ========== 字体大小 ========== */
  --font-size-xs: 12px;
  --font-size-sm: 13px;
  --font-size-base: 14px;
  --font-size-md: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 20px;
  --font-size-2xl: 24px;

  /* ========== 状态颜色映射 ========== */
  --status-online: var(--success-color);
  --status-offline: var(--info-color);
  --status-working: var(--warning-color);
  --status-error: var(--danger-color);
  --status-success-bg: var(--success-light);
  --status-warning-bg: var(--warning-light);
  --status-danger-bg: var(--danger-light);

  /* ========== 统计卡片渐变 ========== */
  --stat-gradient-1: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  --stat-gradient-2: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  --stat-gradient-3: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
  --stat-gradient-4: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  --stat-gradient-5: linear-gradient(135deg, #eab308 0%, #facc15 100%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,8BAA8B;EAC9B,qEAAqE;EACrE,2EAA2E;EAC3E,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;;EAErB,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;;EAErB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;;EAEhC,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;;EAEnC,6BAA6B;EAC7B,+CAA+C;EAC/C,gDAAgD;EAChD,kDAAkD;;EAElD,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;;EAElB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;;EAE5B,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;;EAErB,iCAAiC;EACjC,qCAAqC;EACrC,mCAAmC;EACnC,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,yCAAyC;EACzC,uCAAuC;;EAEvC,iCAAiC;EACjC,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;EACpE,oEAAoE;AACtE","sourcesContent":["/* 全局 CSS 变量 */\n:root {\n  /* ========== 主题色 ========== */\n  --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  --primary-gradient-hover: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);\n  --primary-color: #409EFF;\n  --primary-light: #ecf5ff;\n  --success-color: #67C23A;\n  --success-light: #f0f9eb;\n  --warning-color: #E6A23C;\n  --warning-light: #fdf6ec;\n  --danger-color: #F56C6C;\n  --danger-light: #fef0f0;\n  --info-color: #909399;\n  --info-light: #f4f4f5;\n\n  /* ========== 文字颜色 ========== */\n  --text-primary: #303133;\n  --text-regular: #606266;\n  --text-secondary: #909399;\n  --text-placeholder: #c0c4cc;\n  --text-white: #ffffff;\n\n  /* ========== 背景色 ========== */\n  --bg-page: #f5f7fa;\n  --bg-card: #ffffff;\n  --bg-hover: #f5f7fa;\n  --bg-overlay: rgba(0, 0, 0, 0.5);\n\n  /* ========== 边框颜色 ========== */\n  --border-color-base: #dcdfe6;\n  --border-color-light: #e4e7ed;\n  --border-color-lighter: #ebeef5;\n  --border-color-extra-light: #f2f6fc;\n\n  /* ========== 阴影 ========== */\n  --shadow-card: 0 2px 12px 0 rgba(0, 0, 0, 0.05);\n  --shadow-hover: 0 8px 24px 0 rgba(0, 0, 0, 0.12);\n  --shadow-dropdown: 0 2px 12px 0 rgba(0, 0, 0, 0.1);\n\n  /* ========== 间距 ========== */\n  --spacing-xs: 8px;\n  --spacing-sm: 12px;\n  --spacing-md: 16px;\n  --spacing-lg: 20px;\n  --spacing-xl: 24px;\n  --spacing-2xl: 32px;\n\n  /* ========== 圆角 ========== */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n  --radius-full: 50%;\n\n  /* ========== 过渡动画 ========== */\n  --transition-fast: 0.15s ease;\n  --transition-base: 0.3s ease;\n  --transition-slow: 0.5s ease;\n\n  /* ========== 字体大小 ========== */\n  --font-size-xs: 12px;\n  --font-size-sm: 13px;\n  --font-size-base: 14px;\n  --font-size-md: 16px;\n  --font-size-lg: 18px;\n  --font-size-xl: 20px;\n  --font-size-2xl: 24px;\n\n  /* ========== 状态颜色映射 ========== */\n  --status-online: var(--success-color);\n  --status-offline: var(--info-color);\n  --status-working: var(--warning-color);\n  --status-error: var(--danger-color);\n  --status-success-bg: var(--success-light);\n  --status-warning-bg: var(--warning-light);\n  --status-danger-bg: var(--danger-light);\n\n  /* ========== 统计卡片渐变 ========== */\n  --stat-gradient-1: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  --stat-gradient-2: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n  --stat-gradient-3: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\n  --stat-gradient-4: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n  --stat-gradient-5: linear-gradient(135deg, #eab308 0%, #facc15 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
